<template>
  <div class="layout default">
    <nav class="header">
      <AppHeader />
    </nav>
    <main class="content">
      <slot />
    </main>

    <AppFooter class="footer" />
  </div>
</template>

<style scoped lang="scss">
footer {
  height: 50px;
}
</style>

<style lang="scss">
.container {
  max-width: 960px;
  .top {
    background: var(--pallete_dark_color);
  }
}
</style>
